import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import theme from '../../../../styles/theme';

const StyledErrorMessage = ({ name, classes }) => (
  <ErrorMessage name={name} component="div" className={classes.errorMessage} />
);

StyledErrorMessage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
};

export default compose(
  injectSheet({
    errorMessage: {
      background: theme.colors.brandError,
      color: theme.colors.white,
      textAlign: 'center',
      marginTop: '-17px',
      fontSize: 12,
      maxHeight: '17px',
    },
  }),
)(StyledErrorMessage);
